<template>
  <div style='height: 100%; background-color: white;'>
    <EditPostTop></EditPostTop>
    <EditPostBottom></EditPostBottom>
  </div>
</template>

<script>
import EditPostTop from '@/components/EditPost/EditPostTop';
import EditPostBottom from '@/components/EditPost/EditPostBottom';
import { mapState } from 'vuex';
export default {
  name: 'AddNewPost',
  components: {
    EditPostTop,
    EditPostBottom
  }
};
</script>

<style scoped lang="scss"></style>
